import React from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { Button } from 'antd'
import { MovingStatus, PackType } from '../types'
import PLUSPack from '../img/upload/PLUSPack.svg'
import BASICPack from '../img/upload/BASICPack.svg'

type LinkState = {
  movingStatus: MovingStatus
  packType: PackType
}
const pAnimatedStickerButtonStyle = (color: string) => {
  return {
    backgroundColor: color,
  }
}

const pStillStickerButtonStyle = (color: string) => {
  return {
    color: color,
    border: `0.5px solid ${color}`,
  }
}

const packTypeColor = (type: string) => {
  if (type === 'BASIC') {
    return '#FF7D54'
  }
  // 플러스팩
  return '#4B63F2'
}

function PackTypeChoice({ packType }: { packType: 'PLUS' | 'BASIC' }) {
  // 플러스팩, 베이직팩 svg 크기가 달라 필요한 마진
  // TODO 동일한 사이즈의 svg 이미지로 교체 예정
  const wrapperStyle = {
    marginTop: packType === 'BASIC' ? '30px' : '25px',
  }
  const captionStyle = {
    marginTop: packType === 'BASIC' ? '24px' : '7px',
  }
  const animatedStyle = pAnimatedStickerButtonStyle(packTypeColor(packType))
  const stillStyle = pStillStickerButtonStyle(packTypeColor(packType))

  return (
    <div className="pack-type-frame">
      <div className="pack-type-wrapper" style={wrapperStyle}>
        <img src={packType === 'PLUS' ? PLUSPack : BASICPack} alt={packType} />
        <div className="pack-type-caption" style={captionStyle}>
          <FormattedMessage
            id={`Upload.PkgCreation.selectPackType.${packType}.caption`}
            defaultMessage="caption"
          />
        </div>
        <div className="pack-type-title">
          <FormattedMessage
            id={`Upload.PkgCreation.selectPackType.${packType}.title`}
            defaultMessage="title"
          />
        </div>
        <div className="pack-type-description">
          <FormattedHTMLMessage
            id={`Upload.PkgCreation.selectPackType.${packType}.description`}
            defaultMessage="description"
          />
        </div>
        <div className="pack-type-button-wrapper">
          <Link to={`/upload/create-package/${packType}/ANIMATED`}>
            <Button
              className="pack-type-animated-sticker-button"
              icon="plus"
              style={animatedStyle}
            >
              <FormattedHTMLMessage
                id="Upload.PkgCreation.selectPackType.animatedStickerButton"
                defaultMessage="animatedSticker"
              />
            </Button>
          </Link>
          <Link to={`/upload/create-package/${packType}/STILL`}>
            <Button
              className="pack-type-still-sticker-button"
              icon="plus"
              style={stillStyle}
            >
              <FormattedHTMLMessage
                id="Upload.PkgCreation.selectPackType.stillStickerButton"
                defaultMessage="stillSticker"
              />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PackTypeChoice
